import React from "react";
import styles from "./styles.module.scss";

const FileIcon = () => <span className={styles.fileIcon} />;

export default FileIcon;
